// extracted by mini-css-extract-plugin
export var statItem = "_jk-1";
export var statsRow = "_jk-0";